import { ReactElement, ReactNode, useSyncExternalStore } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { getImpersonation, subscribeImpersonation } from '@/lib/impersonation'
import { selectIsWisprInternal } from '@/store/features/user/userSlice'

const WisprInternalRoute = ({ children }: { children: ReactNode }): ReactElement => {
  const isWisprInternal = useSelector(selectIsWisprInternal)
  const impersonating = useSyncExternalStore(subscribeImpersonation, getImpersonation)
  // Never while impersonating: internal calls would run under the impersonated tenant.
  if (!isWisprInternal || impersonating) return <Navigate to="/app/home" replace />
  return <>{children}</>
}

export default WisprInternalRoute
